import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBreadcrumbs,{staticClass:"pa-0 mb-1",attrs:{"items":_vm.items,"divider":">"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c(VBreadcrumbsItem,{attrs:{"exact":"","to":item.to}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }